import { render, staticRenderFns } from "./DetailsPageHeader.vue?vue&type=template&id=1551040e&scoped=true"
import script from "./DetailsPageHeader.vue?vue&type=script&lang=js"
export * from "./DetailsPageHeader.vue?vue&type=script&lang=js"
import style0 from "./DetailsPageHeader.vue?vue&type=style&index=0&id=1551040e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1551040e",
  null
  
)

export default component.exports